import React from 'react';
import { ImStack } from 'react-icons/im';
import { IoTrashBinOutline } from 'react-icons/io5';

const TabWithIcon = ({ icon, text }) => (
  <span className="flex_center">
    {icon}
    {text}
  </span>
);

const tabList = [
  {
    tab: <TabWithIcon text="All" icon={<ImStack style={{ marginRight: 8 }} />} />,
    key: 'all',
  },
  {
    tab: <TabWithIcon text="Trash" icon={<IoTrashBinOutline style={{ marginRight: 8 }} />} />,
    key: 'trash',
  },
];

export default tabList;
